import { render, staticRenderFns } from "./VisitorsReport.vue?vue&type=template&id=0b04020a"
import script from "./VisitorsReport.vue?vue&type=script&lang=js"
export * from "./VisitorsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports